import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderIt = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Indovina dove sono i soldi."
                highlights={[
                    { word: 'Indovina' },
                    { word: 'dove' },
                    { word: 'sono' },
                    { word: 'i' },
                    { word: 'soldi.' },
                ]}
                breakAfterWords={isDesktop ? [] : ['dove']}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Hai tre tentativi!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
